import type { PickActions } from '@core/ngrx-legacy';
import { createSingleEntityStore } from '@core/ngrx-legacy';
import type { OAuthCounters } from '@core/oauth-types';

const { actions, reducer, namespace, selectors } =
  createSingleEntityStore<OAuthCounters>()('OAuthCounters');

const OAuthCountersActions: PickActions<typeof actions, 'fetch'> = actions;

export {
  OAuthCountersActions,
  reducer as OAuthCountersReducer,
  namespace as OAuthCountersNamespace,
  selectors as OAuthCountersSelectors,
};
